import React from 'react';

import './main.css';

export default function TurnkeyWorks() {
  return (
    <>
      <div className="turnkey-works">
        <div className="turnkey-footer"></div>
        <div className="turnkey">
          <div className="box-title">
            <div className="title">
              <h1>Что входит в стоимость работ под ключ?</h1>
            </div>
            <div className="colors">
              <div className="free">
                <span></span>
                <p>Бесплатно</p>
              </div>
              <div className="pro">
                <span></span>
                <p>Входит в стоимость</p>
              </div>
            </div>
          </div>
          <div className="header">
            <div className="header-box">
              <span className="free">1</span>
              <p>Консультация по телефону</p>
            </div>
            <div className="header-box">
              <span className="free">2</span>
              <p>Бесплатный замер</p>
            </div>
            <div className="header-box">
              <span>3</span>
              <p>Производство окна</p>
            </div>
            <div className="header-box">
              <span>4</span>
              <p>Доставка по городу</p>
            </div>
            <div className="header-box">
              <span>5</span>
              <p>Подъем на любой этаж</p>
            </div>
            <div className="header-box">
              <span>6</span>
              <p>Монтаж и уборка мусора</p>
            </div>
            <div className="header-box">
              <span>7</span>
              <p>Откосы</p>
            </div>
            <div className="header-box">
              <span>8</span>
              <p>Водоотлив</p>
            </div>
            <div className="header-box">
              <span>9</span>
              <p>Подоконник</p>
            </div>
            <div className="header-box">
              <span>10</span>
              <p>Нащельник</p>
            </div>
            <div className="header-box">
              <span className="free">11</span>
              <p>Москитная сетка</p>
            </div>
            <div className="header-box">
              <span className="free">12</span>
              <p>Гарантия 5 лет</p>
            </div>
            <button className='calculate-the-cost'>Рассчитать стоимость</button>
          </div>
        </div>
      </div>
    </>
  )
}
